import { FormattedMessage } from "react-intl";

import { ListingData, useListingData } from "~/context/ListingPageDataContext";

import { getIsInstantBookOffered } from "../book-listing-utils";
import { useBookListingContext } from "../BookListingContext";
import HostResponsiveness from "../HostResponsiveness";
import { InstantBookNote } from "../InstantBookNote";

import { Text } from "@/components/atoms/Text";

export const BookListingCardFooter = () => {
  const { data: listingData = {} as ListingData } = useListingData();
  const { quote } = useBookListingContext();
  const { booking } = quote?.spaceRentalContract?.meta || {};

  const isInstantBookOffered = getIsInstantBookOffered({
    booking,
    listingData,
  });

  const displayInstantBook = quote
    ? (booking?.is_instant_booking ?? false)
    : listingData.isInstantBookActive;

  const currentUnixTime = new Date().valueOf();
  const showCancelCopy =
    !!listingData.cancellationPolicy &&
    currentUnixTime >= listingData.cancellationPolicy.ts_active;

  const bookingDuration = booking?.duration ?? 0;

  return isInstantBookOffered ? (
    <InstantBookNote
      displayInstantBook={displayInstantBook}
      showNewCancelCopy={showCancelCopy}
      isMinimumDuration={
        bookingDuration >= parseFloat(listingData.listingMinimumDuration ?? "0")
      }
    />
  ) : (
    !!listingData.listingHostResponsiveness?.hours && (
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-8 tw-mt-8 tw-text-gray-600">
        <HostResponsiveness
          ownerName={listingData.listingOwnerFirstName}
          hostResponsiveness={listingData.listingHostResponsiveness}
          isFullServiceVenue={listingData.fullService?.active}
        />
        {showCancelCopy && (
          <div id="cancel-for-free-copy">
            <Text typeface="body-1-long">
              <FormattedMessage defaultMessage="You won't be charged yet." />
            </Text>
          </div>
        )}
      </div>
    )
  );
};
